<template>
  <div class="border-bottom">
    <view-base :post="post" :comment="comment" @reply="$emit('reply', {contribution: comment, saveParentID: true})" :selectedID="selectedID" :isGrid="isGrid"></view-base>
    <div v-if="replies.length > 0" class="replies">
      <view-base v-for="reply in replies" :post="post" :key="reply.id" :comment="reply" @reply="$emit('reply', {contribution: comment, saveParentID: true})" @fetch="fetchReplies" :isGrid="isGrid" :selectedCommentID="selectedCommentID"></view-base>
    </div>
  </div>
</template>

<script>
import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'

import ViewBase from './ViewBase'

export default {
  props: ['comment', 'post', 'selectedID', 'isGrid', 'selectedCommentID'],
  mixins: [auth, componentState],
  components: {
    ViewBase
  },
  data: function () {
    return {
      reply: false
    }
  },
  mounted: function () {
    if (this._get(this.createKey())) {
      this.reply = true
    }
    if (this.selectedCommentID) {
      this.$emit('scrollToCommentBox')
    }
  },
  computed: {
    replies: function () {
      return this.comment.metadata.replies > 0 ? this.$store.getters.commentReplies(this.comment.id) : []
    }
  },
  methods: {
    createKey: function (isUpdate) {
      return this._uicreateKey(this.post.projectID, this.comment, this.post, isUpdate)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

 .border-bottom{
   border-bottom: 2px solid #f2f2f2;
 }

.comment-box{
  .text{
    position: relative;
    padding-top: 3rem;
    padding-left:1rem;
  }
  .card-container-comment{
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    .card-image-container{
      display:flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
          img{
              width:30px;
          }
          .poster{
              padding-left:0.3rem;
              font-weight:400;
              font-size:0.85rem;
          }
      }
  }
}

  .post-text {
    width: 100%;
    height: auto;
    position: relative;
    .gradient-line {
      background: $secondary-gradient;
      height: 1px;
      width: 100%;
      margin: 0 0 0.5rem 0;
    }
    .post-text-input {
      width: 100%;
      border: none;
      outline: none;
      box-shadow: none;
      resize: none;
      padding: 0 0 0.5rem 0;
      margin-top: 3rem;
      @include mini-mobile {
        margin-top: 4rem;
      }
    }
    .post-text-input-short {
      margin-top: 1rem;
    }
  }
  .post-btn {
    padding: 0 3rem;
    margin: 0.5rem 0;
    height: 2.5rem;
    font-size: 0.9rem;
  }

  .like{
    color:#ADAAAA;
    font-size:0.9rem;
    margin: 0.75rem 0.2rem 0 0.2rem;
    position:relative;
    cursor:pointer;
    @include mobile{
    margin: 0.5rem 0.2rem 0.25rem 0.2rem;
    }
    .active{
      color: $dark;
    }
    span{
        margin-left:1rem;
        &:nth-child(1){
            margin-left:0;
        }
        &:nth-child(3){
            position:absolute;
            right:0;
        }
    }
    .views{
    position:absolute;
    right:25px;
    @include tablet{
    display: none;
    }
    }

  .has-liked {
    color: $primary;
  }
}

.reply {
  padding: 1rem 1rem 2rem 4rem;
  @include mobile {
    padding: 1rem 1rem 2rem 1.5rem;
  }
}

.replies {
  padding-left: 4rem;
  @include mobile {
    padding-left: 1rem;
  }
}
</style>
